import React, { Component } from 'react'
import Radium from 'radium';
import { Treebeard, decorators } from '../treebeard';

import auth from '../../../../Login/authService'

const propTypes = {}

const defaultProps = {}

const decs = {
    ...decorators,
    Header: (props) => {
        if (props.node.root) {
            return (
                <div style={props.style.base}>
                    <div style={{ ...props.style.title, }}>
                        {props.node.name}
                    </div>
                </div >
            )
        }
        if (props.node.children && props.node.apv) {
            return (
                <div style={props.style.base}>
                    <div style={{ ...props.style.title, }}>
                        {props.node.name}
                    </div>
                </div>
            )
        }
        if (props.node.children) {
            return (
                <div style={props.style.base}>
                    <div style={props.style.title}>
                        <div style={{ display: 'inline-block', }}>
                            {props.node.name}
                        </div>
                    </div>
                </div >
            );
        } else {
            return (
                <div className="waves-btn" style={{ ...props.style.base, width: '98%', textAlign: 'left' }}>
                    <div style={props.style.title}
                        onClick={() => props.show(props.node)}
                    >
                        <i
                            style={{ paddingTop: 0, cursor: 'pointer', width: 20, fontSize: 18 }}
                            className="fa fa-search"
                            aria-hidden="true"
                        />
                        {props.node.name}
                    </div>
                </div>
            );
        }
    }
};

class Dokumenter extends Component {
    render() {
        return (
            <Treebeard
                style={styles.treebeard}
                data={this.props.data}
                onToggle={this.props.onToggle}
                show={this.props.show}
                decorators={auth.getProfile().role === 'Formand' ? decs : decorators}
            />
        )
    }
}

const styles = {
    treebeard: {
        tree: {
            base: {
                listStyle: 'none',
                backgroundColor: '#f7f7f7',
                margin: 0,
                padding: 0,
                fontSize: '14px'
            },
            node: {
                base: {
                    position: 'relative'
                },
                link: {
                    cursor: 'pointer',
                    position: 'relative',
                    padding: '0px 5px',
                    display: 'block'
                },
                activeLink: {
                    background: 'inherit'
                },
                toggle: {
                    base: {
                        position: 'relative',
                        display: 'inline-block',
                        verticalAlign: 'top',
                        marginLeft: '-5px',
                        height: '24px',
                        width: '24px',
                        paddingTop: 35
                    },
                    wrapper: {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        margin: '-7px 0 0 -7px',
                        height: '10px'
                    },
                    height: 10,
                    width: 10,
                    arrow: {
                        fill: '#4a4a4a',
                        strokeWidth: 0
                    }
                },
                header: {
                    base: {
                        display: 'inline-block',
                        verticalAlign: 'top',
                        width: '95%',
                    },
                    connector: {
                        width: '2px',
                        height: '12px',
                        borderLeft: 'solid 2px black',
                        borderBottom: 'solid 2px black',
                        position: 'absolute',
                        top: '0px',
                        left: '-21px'
                    },
                    title: {
                        lineHeight: '40px',
                        verticalAlign: 'middle'
                    }
                },
                subtree: {
                    listStyle: 'none',
                    paddingLeft: '19px'
                },
                loading: {
                    color: '#E2C089'
                }
            }
        }
    }
}

Dokumenter.propTypes = propTypes

Dokumenter.defaultProps = defaultProps

export default Radium(Dokumenter)



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Arbejdsmiljo/Apvs/dokumenter.js